export default {
  bell: require("./bell.mp3"),
  light: require("./light.mp3"),
  point: require("./point.mp3"),
};
